import CONSTANTS from "./constants";
const initialState = {
  tabListLoading: false,
  tabListFailure: false,
  tabListData: {},

  overViewDetailsLoading: false,
  overViewDetailsFailure: false,
  overViewDetails: {},

  individualInstallmentData: {},
  individualInstallmentDataLoading: false,
  individualInstallmentDataFailure: false,

  priceDetailsLoading: false,
  priceDetailsFailure: false,
  priceDetails: {},

  userDetailsLoading: false,
  userDetailsFailure: false,
  userDetails: {},

  postLikeCourseSuccess: false,
  postLikeCourseError: false,
  isCourseLiked: false,

  //Prev order id
  prevOrderId: null,

  //retry payment
  retryingPayment: false,

  //price Details
  graphCourseData: {},
  graphCourseDataStatus: "",
  graphCourseDataLoading: false,
  graphCourseDataError: false,

  //coupon Details
  graphCourseCouponListData: {},
  graphCourseCouponListDataStatus: "",
  graphCourseCouponListDataLoading: false,
  graphCourseCouponListDataError: false,

  showCouponsEverywhere: false,
  multipleCouponsConditions: 2,
  currentCouponCode: {},

  //apply Coupon
  applyCouponData: {},
  applyCouponDataStatus: "",
  applyCouponDataLoading: false,
  applyCouponDataError: false,

  //remove Coupon
  removeCoupon: {},
  removeCouponStatus: "",
  removeCouponLoading: false,
  removeCouponError: false,

  stateSelected: "",
  showApplyCouponPopup: "",

  graphCouponListOffset: 0,
  isInstallmentPayment: 0,

  showForcefulShimmer: false,

  isCouponModal: false,
  showBuyNowSuccess: false,
  whatsappPaymentLoading: false,

  paymentOptions: [],

  courseFacultyList: null,
  dynamicCourse: {
    isLoading: true,
    courseList: [],
  },
  dynamicCoursePrice: {},
  dynamicBundleList: [],
  dynamicBundlingLoading: false,

  // COMBO COURSES
  comboCourseList: [],
  comboCourseId: "",
  standAloneUrl: "",

  moneyBackGuarantee:{
    addOnOptionId: 0,
    prePurchaseAddOnAmount: 0,
    prePurchasePopUpEnabled:0,
    isRemoveButtonEnable: true,
  },
};

const addTabListsFn = (state, action) => {
  // console.log(action.payload, state, "addTabListsFn--------------------");
  // console.log({ ...state, tabListData: action.payload }, "state--");
  return {
    ...state,
    tabListData: action.payload,
    tabListLoading: false,
    tabListFailure: false,
  };
};
const selectedState = (state, action) => {
  return {
    ...state,
    stateSelected: action?.payload,
  };
};
const priceDetailsFn = (state, action) => {
  return {
    ...state,
    priceDetails: action.payload,
    priceDetailsLoading: false,
    priceDetailsFailure: false,
  };
};

const overViewDetailsFn = (state, action) => {
  const overViewDetails = action.payload;
  return {
    ...state,
    overViewDetails,
    overViewDetailsLoading: false,
    overViewDetailsFailure: false,
    ...(overViewDetails?.course?.enablePrefilledState
      ? {
          stateSelected:
            overViewDetails?.course?.prefillState?.name || state.stateSelected,
        }
      : {}),
  };
};
const userDetailsFn = (state, action) => {
  return {
    ...state,
    userDetailsFailure: false,
    userDetailsLoading: false,
    userDetails: action.payload,
  };
};

const getGraphCourseFn = (state, action) => {
  return {
    ...state,
    graphCourseDataLoading: action.graphCourseDataLoading,
    graphCourseDataStatus: action.graphCourseDataStatus,
  };
};

const getGraphCourseSuccessFn = (state, action) => {
  return {
    ...state,
    graphCourseData: action.graphCourseData,
    graphCourseDataLoading: action.graphCourseDataLoading,
    graphCourseDataError: action.graphCourseDataError,
    graphCourseDataStatus: action.graphCourseDataStatus,
    currentCouponCode: action.currentCouponCode,
  };
};

const getGraphCourseFailureFn = (state, action) => {
  return {
    ...state,
    graphCourseData: action.graphCourseData,
    graphCourseDataLoading: action.graphCourseDataLoading,
    graphCourseDataError: action.graphCourseDataError,
    graphCourseDataStatus: action.graphCourseDataStatus,
  };
};

const getGraphCouponListFn = (state, action) => {
  return {
    ...state,
    graphCourseCouponListDataLoading: true,
    graphCourseCouponListDataStatus: "",
  };
};

const updateLikeCourseCountFn = (state, liked) => {
  const currLike = state?.overViewDetails?.course?.likes?.value;
  const currIsLiked = state?.overViewDetails?.course?.metaData?.isLiked;
  let updatedLike;
  if (Number(currLike) === 1) {
    updatedLike = (
      liked ? Number(currLike) + 1 : Number(currLike) - 1
    ).toString();
  } else {
    updatedLike = (
      (liked ? Number(currLike) + 1 : Number(currLike) - 1) || currLike
    ).toString();
  }
  const updatedIsLiked = liked ? 1 : 0;
  return {
    ...state,
    overViewDetails: {
      ...state?.overViewDetails,
      course: {
        ...state?.overViewDetails?.course,
        likeText: updatedLike,
        likes: {
          ...state?.overViewDetails?.course?.likes,
          value: updatedLike,
        },
        metaData: {
          ...state?.overViewDetails?.course?.metaData,
          isLiked: updatedIsLiked,
        },
      },
    },
  };
};
const setUpcomingLiveClass = (state, action) => {
  let priorityOrderList = [...state?.overViewDetails?.course?.priorityOrderList];
  if (action?.payload?.goLiveCardMobile && Array.isArray(priorityOrderList)) {
    priorityOrderList?.unshift(action?.payload?.goLiveCardMobile)
  }
  return {
    ...state,
    overViewDetails: {
      ...state?.overViewDetails,
      course: {
        ...state?.overViewDetails?.course,
        upcomingLiveClasses: {
          ...action?.payload,
          data: action?.payload?.list
        },
        priorityOrderList: priorityOrderList
      },
    },
  };
};

const getGraphCouponListSuccessFn = (state, action) => {
  let { showCouponsEverywhere, multipleCouponsConditions } = state;
  let { graphCourseCouponListData } = action;

  if (graphCourseCouponListData) {
    // console.log(graphCourseCouponListData.totalCount, '%%%%%totalCount');
    if (graphCourseCouponListData.totalCount > 0) {
      showCouponsEverywhere = true;
      if (graphCourseCouponListData.inVisibleCouponCount >= 1) {
        multipleCouponsConditions = 1;
      } else {
        multipleCouponsConditions = 2;
      }
    } else if (graphCourseCouponListData.inVisibleCouponCount >= 1) {
      showCouponsEverywhere = true;
      multipleCouponsConditions = 3;
    } else if (
      graphCourseCouponListData.totalCount == 0 &&
      graphCourseCouponListData.inVisibleCouponCount == 0
    ) {
      showCouponsEverywhere = false;
    }
  }
  return {
    ...state,
    graphCourseCouponListData: action.graphCourseCouponListData,
    graphCourseCouponListDataLoading: action.graphCourseCouponListDataLoading,
    graphCourseCouponListDataError: action.graphCourseCouponListDataError,
    graphCourseCouponListDataStatus: action.graphCourseCouponListDataStatus,
    showCouponsEverywhere,
    multipleCouponsConditions,
    graphCouponListOffset: action.updateGraphCourseCouponOffset
      ? state.graphCouponListOffset + 20
      : 0,
  };
};

const getGraphCouponListFailureFn = (state, action) => {
  return {
    ...state,
    graphCourseCouponListData: action.graphCourseCouponListData,
    graphCourseCouponListDataLoading: action.graphCourseCouponListDataLoading,
    graphCourseCouponListDataError: action.graphCourseCouponListDataError,
    graphCourseCouponListDataStatus: action.graphCourseCouponListDataStatus,
  };
};

const applyCouponFn = (state, action) => {
  return {
    ...state,
    applyCouponDataLoading: true,
  };
};

const applyCouponSuccessFn = (state, action) => {
  return {
    ...state,
    applyCouponDataLoading: false,
    applyCouponData: action.payload,
    applyCouponDataError: false,
    showApplyCouponPopup: true,
  };
};

const applyCouponFailureFn = (state, action) => {
  return {
    ...state,
    applyCouponDataLoading: false,
    applyCouponDataError: true,
  };
};

const applyCouponPopupFn = (state, action) => {
  return { ...state, showApplyCouponPopup: action.payload };
};
const funnelTrackingHistoryObjectFn = (state, action) => {
  return {
    ...state,
    funnelTrackingHistoryObject: {
      ...state?.funnelTrackingHistoryObject,
      ...action.payload,
    },
  };
};
const individualInstallmentDataFn = (state, action) => {
  return {
    ...state,
    individualInstallmentData: action.payload,
    individualInstallmentDataLoading: false,
    individualInstallmentDataError: false,
  };
};
const individualInstallmentDataFailureFn = (state, action) => {
  return {
    ...state,
    individualInstallmentData: {},
    individualInstallmentDataLoading: false,
    individualInstallmentDataError: true,
  };
};
const individualInstallmentDataLoadingFn = (state, action) => {
  return {
    ...state,
    individualInstallmentDataLoading: true,
    individualInstallmentDataError: false,
    individualInstallmentData: {},
  };
};

const setCurrentCouponFn = (state, action) => {
  // console.log(action.payload, "+++++payload");

  return {
    ...state,
    currentCouponCode: action.payload.coupon,
  };
};

const setPrevOrderId = (state, action) => {
  return {
    ...state,
    prevOrderId: action.payload,
  };
};

const setRetryingPayment = (state, action) => {
  return {
    ...state,
    retryingPayment: action.payload,
  };
};

const updateIsInstallmentPayment = (state, action) => {
  return {
    ...state,
    isInstallmentPayment: action.payload,
  };
};

const courseFacultyListReducer = (state, action) => {
  return {
    ...state,
    courseFacultyList: action?.payload,
  };
};

const reducer = (state = initialState, action) => {
  // console.log(action, "00000-0=");
  switch (action.type) {
    case CONSTANTS.GET_TAB_LIST_DATA_LOADER:
      return { ...state, tabListLoading: true, tabListFailure: false };
    case CONSTANTS.GET_TAB_LIST_DATA_FAILURE:
      return { ...state, tabListFailure: true, tabListLoading: false };
    case CONSTANTS.GET_TAB_LIST_DATA_SUCCESS:
      return addTabListsFn(state, action);

    //
    case CONSTANTS.GET_OVERVIEW_DATA_LOADER:
      return {
        ...state,
        overViewDetailsLoading: true,
        overViewDetailsFailure: false,
      };
    case CONSTANTS.GET_OVERVIEW_DATA_FAILURE:
      return {
        ...state,
        overViewDetailsFailure: true,
        overViewDetailsLoading: false,
      };
    case CONSTANTS.SET_OVERVIEW_DATA_DIRECTLY_IN_STORE:
      return {
        ...state,
        overViewDetails: { ...action.payload },
        overViewDetailsLoading: false,
      };
    case CONSTANTS.GET_OVERVIEW_DATA_SUCCESS:
      return {
        ...overViewDetailsFn(state, action),
        userDetails: {
          responseData: {
            user: action?.payload?.course?.studentUserInfo,
          },
        },
        ...(action?.payload?.course?.multipleValidity && {
          multipleValidity: action?.payload?.course?.multipleValidity,
          promotedValidity:
            localStorage.getItem("selectedValidity") &&
            JSON.parse(localStorage.getItem("selectedValidity"))?.courseId ===
              window?.location?.pathname?.split("/")[1]
              ? JSON.parse(localStorage.getItem("selectedValidity"))
              : action?.payload?.course?.multipleValidity.reduce(function (
                  curr,
                  acc
                ) {
                  if (curr.isPromoted === 1) {
                    acc = { ...curr };
                  }
                  return acc;
                },
                {}),
        }),
        ...(action?.payload?.course?.multipleValiditySelected && {
          multipleValiditySelected:
            action?.payload?.course?.multipleValiditySelected,
        }),
      };
    //
    case CONSTANTS.GET_COURSE_PRICE_SUCCESS:
      return priceDetailsFn(state, action);

    //
    case CONSTANTS.GET_USER_DETAILS_LOADING:
      return {
        ...state,
        userDetailsLoading: true,
        userDetailsFailure: false,
      };
    case CONSTANTS.GET_USER_DETAILS_ERROR:
      return {
        ...state,
        userDetailsFailure: true,
        userDetailsLoading: false,
      };
    case CONSTANTS.GET_USER_DETAILS_SUCCESS:
      return userDetailsFn(state, action);
    case CONSTANTS.POST_LIKE_COURSE_ERROR:
      return {
        ...state,
        postLikeCourseError: true,
        postLikeCourseSuccess: false,
      };
    case CONSTANTS.POST_LIKE_COURSE_SUCCESS:
      return {
        ...state,
        postLikeCourseError: false,
        postLikeCourseSuccess: true,
      };
    case CONSTANTS.POST_LIKE_COURSE_RESET: {
      return {
        ...state,
        postLikeCourseError: false,
        postLikeCourseSuccess: false,
      };
    }

    case CONSTANTS.GET_GRAPH_COURSE_PRICE_DETAILS_LOADER:
      return getGraphCourseFn(state, action);
    case CONSTANTS.GET_GRAPH_COURSE_PRICE_DETAILS_SUCCESS:
      return getGraphCourseSuccessFn(state, action);
    case CONSTANTS.GET_GRAPH_COURSE_PRICE_DETAILS_FAILURE:
      return getGraphCourseFailureFn(state, action);

    case CONSTANTS.GET_GRAPH_COUPONS_LIST_LOADER:
      return getGraphCouponListFn(state, action);
    case CONSTANTS.GET_GRAPH_COUPONS_LIST_SUCCESS:
      return getGraphCouponListSuccessFn(state, action);
    case CONSTANTS.GET_GRAPH_COUPONS_LIST_FAILURE:
      return getGraphCouponListFailureFn(state, action);

    case CONSTANTS.APPLY_COURSE_COUPON_LOADER:
      return applyCouponFn(state, action);
    case CONSTANTS.APPLY_COURSE_COUPON_SUCCESS:
      return applyCouponSuccessFn(state, action);
    case CONSTANTS.APPLY_COURSE_COUPON_FAILURE:
      return applyCouponFailureFn(state, action);
    case CONSTANTS.SET_SELECTED_STATE:
      return selectedState(state, action);
    case CONSTANTS.APPLY_COUPON_SUCCESS_POPUP:
      return applyCouponPopupFn(state, action);
    case CONSTANTS.FUNNEL_TRACKING_HISTORY_OBJECT:
      return funnelTrackingHistoryObjectFn(state, action);
    case CONSTANTS.GET_INDIVIDUAL_INSTALLMENT_LOADER:
      return individualInstallmentDataLoadingFn(state, action);
    case CONSTANTS.GET_INDIVIDUAL_INSTALLMENT_SUCCESS:
      return individualInstallmentDataFn(state, action);
    case CONSTANTS.GET_INDIVIDUAL_INSTALLMENT_FAILURE:
      return individualInstallmentDataFailureFn(state, action);
    case CONSTANTS.SET_CURRENT_COUPON_CODE:
      return setCurrentCouponFn(state, action);
    case CONSTANTS.SET_PREV_ORDER_ID:
      return setPrevOrderId(state, action);

    case CONSTANTS.SET_RETRYING_PAYMENT:
      return setRetryingPayment(state, action);

    case CONSTANTS.UPDATE_COURSE_LIKE_COUNT: {
      return updateLikeCourseCountFn(state, action?.payload);
    }
    case CONSTANTS.SET_UPCOMING_LIVE_CLASS: {
      return setUpcomingLiveClass(state, action);
    }

    case CONSTANTS.IS_INSTALLMENT_PAYMENT: {
      return updateIsInstallmentPayment(state, action);
    }

    case CONSTANTS.SET_FORCEFUL_SHIMMER: {
      return {
        ...state,
        showForcefulShimmer: action?.payload,
      };
    }

    case CONSTANTS.SET_VALIDITY:
      return {
        ...state,
        promotedValidity: action?.payload,
      };

    case CONSTANTS.SHOW_COUPON_MODAL:
      return {
        ...state,
        isCouponModal: action?.payload?.isCouponModal,
      };
    case CONSTANTS.SET_PAYMENT_OPTIONS:
      return {
        ...state,
        paymentOptions: action?.payload,
      };
    case CONSTANTS.SAVE_COURSE_FACULTY_LIST: {
      return courseFacultyListReducer(state, action);
    }

    case CONSTANTS.BUY_NOW_SUCCESS_MODAL:
      return {
        ...state,
        showBuyNowSuccess: action?.payload,
      };

    case CONSTANTS.WHATSAPP_PAYMENT_LOADING:
      return {
        ...state,
        whatsappPaymentLoading: action?.payload,
      };
    case CONSTANTS.GET_DYNAMIC_COURSE_LIST_SUCCESS:
      return {
        ...state,
        dynamicCourse: {
          isloading: false,
          courseList: action?.payload,
        },
      };
    case CONSTANTS.GET_DYNAMIC_COURSE_LIST_FAILURE:
      return {
        ...state,
        dynamicCourse: {
          isloading: true,
          courseList: [],
        },
      };
    case CONSTANTS.GET_DYNAMIC_COURSE_PRICE_SUCCESS:
      return {
        ...state,
        dynamicCoursePrice: action?.payload,
      };
    case CONSTANTS.SET_DYNAMIC_BUNDLING_SELECTED:
      return {
        ...state,
        dynamicBundleList: action?.payload,
      };
    case CONSTANTS.SET_DYNAMIC_BUNDLING_BTN_LOADER:
      return {
        ...state,
        dynamicBundlingLoading: action?.payload,
      };
    case CONSTANTS.UPDATE_PHYSICAL_DELIVERY_ENABLED:
      return {
        ...state,
        overViewDetails: {
          ...state.overViewDetails,
          course: {
            ...state?.overViewDetails?.course,
            metaData: {
              ...state?.overViewDetails?.course?.metaData,
              isPhysicalDeliveryEnabled: action?.payload,
            },
          },
        },
      };
    case CONSTANTS.SET_COMBO_COURSE_LIST:
      return {
        ...state,
        comboCourseList: action.payload,
      };
    case CONSTANTS.SET_COMBO_COURSE_ID:
      return {
        ...state,
        comboCourseId: action.payload,
      };
    case CONSTANTS.SET_STANDALONE_URL:
      return {
        ...state,
        standAloneUrl: action.payload,
      }

    case CONSTANTS.MONEY_BACK_GUARANTEE: {
      return {
        ...state,
        moneyBackGuarantee :{...action?.payload},
      }
    }
    case CONSTANTS.MONEY_BACK_GUARANTEE_PRICE: {
      return {
        ...state,
        moneyBackGuarantee :{
          ...state.moneyBackGuarantee,
          prePurchaseAddOnAmount:action.payload
        },
      }
    }
    
    default:
      return state;
  }
};
export default reducer;
